<template>
  <div>
    <CCardHeader>
      <CampaignViewHeader
        title="Data quality"
        :disable-member-select="!selected_member"
        :selected-member-id="selected_member"
        :update-member-id-function="changeMember"
      />
    </CCardHeader>
    <CCardBody>
      <h5>{{ $t("Data Validation") }}</h5>
      <DotsLoader v-if="is_loading"/>
      <table-component
        v-else-if="rapportData && selected_member"
        :data="rapportData"
        :columns="['test', 'result']"
        :headings="{ result: $t('Result') }"
      >
      </table-component>
    </CCardBody>
  </div>
</template>

<script>
import CampaignViewHeader from "@/components/CampaignViewHeader";
import { request } from "@/utils/request";
import { MEMBERS_ENDPOINTS } from "@/services/members";
import { CampaignMixin } from "@/mixins/campaign";
import { MemberService } from "@/services/members";


export default {
  name: "CampaignDataAnalysis",
  components: {CampaignViewHeader},
  mixins: [CampaignMixin],
  data() {
    return {
      MEMBERS_ENDPOINTS,
      members_options: [],
      selected_member: undefined,
      campaignId: this.$route.params.campaignId,
      fileId: undefined,
      rapportData: [],
      is_loading: true,
    };
  },
  async mounted() {
    this.is_loading = true
    const members = await MemberService.getMembers()
    this.members_options = members.map((member) => ({
      value: member.id_member,
      label: member.name,
      code_cpt: member.code_cpt,
      code_gda: member.code_gda,
    }));
    this.selected_member = Number(this.$route.params.id)
    await this.getFileData();
    this.is_loading = false
  },
  methods: {
    changeMember(member_id) {
      this.$router.push({name: 'Data quality', params: {campaignId: this.$route.params.campaignId, id: member_id}});
    },
    async getFileData() {
      const { data } = await request({
        url: MEMBERS_ENDPOINTS.fileAnalysis(
          this.selected_member,
          this.campaignId,
        ),
      });
      if (data?.message) {
        this.rapportData = []
        this.fileId = undefined
        alert(data.message)
        return
      }
      this.rapportData = data?.rapport_data || [];
      this.fileId = data?.file_id || undefined
    },
  },
};
</script>
